module.exports = __webpack_public_path__ + "static/img/logo.8cdc2a6c.png";